/*
 * @Author: your name
 * @Date: 2022-11-18 09:40:20
 * @LastEditTime: 2023-04-26 10:31:07
 * @LastEditors: guozhenqiang 15138913894@163.com
 * @Descripttion: In User Settings Edit
 * @FilePath: /baichuan-website/src/request/api.js
 */
import { get, post, put, deletes } from "./http";

// 技术专利,技术中心列表
export const getCenterList = params => get("/app/centre-list", params);
// 技术专利,技术中心列表
export const getEnglishCenterList = params => get("/app/en/centre-list", params);

// 培训提升查询
export const getCultivateList = params => get("/app/cultivate-list", params);

// 后台管理发展历程列表
export const getDevelopList = params => get("/app/get-develop", params);
// 英文后台管理发展历程列表
export const getEnglishDevelopList = params => get("/app/en/get-develop", params);

// 后台管理企业荣誉列表
export const getHonorList = params => get("/app/get-honour", params);
// 英文后台管理企业荣誉列表
export const getEnglishHonorList = params => get("/app/en/get-honour", params);

// 社会责任报告查询
export const getReportList = params => get("/app/get-report", params);

// 投资者关系查询
export const getInvestList = params => get("/app/invest-page", params);

// 新闻资讯,媒体动态列表
export const getNewsList = params => get("/app/list", params);

// 招聘信息查询
export const getRecruitList = params => get("/app/recruit-list", params);

// 沼气发电,移动储能查询
export const getSchemeList = params => get("/app/scheme-list", params);
// 英文沼气发电,移动储能查询
export const getEnglishSchemeList = params => get("/app/en/scheme-list", params);

// 官网端图片管理查询
export const getWebsiteImg = params => get("/app/website-get", params);
// 官网端图片管理查询
export const getEnglishWebsiteImg = params => get("/app/en/website-get", params);

// 官网公司简介企业愿景管理查询
export const getCompanyDetail = params =>
  get("/app/website-get-introduction", params);
// 英文官网公司简介企业愿景管理查询
export const getEnglishCompanyDetail = params =>
  get("/app/en/website-get-introduction", params);

// 官网公司职业发展规划，员工福利查询
export const getWorkDetail = params => get("/app/website-get-work", params);

// 新闻资讯详情
export const getNewsDetail = params => get("/app/detail", params);

// 企业价值观查询
export const getValue = params => get("/app/get-value", params);

// 发展历程年列表
export const getDevelopYear = params => get("/app/get-develop-year", params);

// 社会责任报告年份查询
export const getReportYear = params => get("/app/get-report-year", params);
// 解决方案-沼气发电,移动储能项目流程图查询
export const getImagesQuery = params => get("/app/v2/project-flow-images-query", params);
// 英文版解决方案-沼气发电,移动储能项目流程图查询
export const getEnglishImagesQuery = params => get("/app/en/project-flow-images-query", params);




// WEBPACK FOOTER //
// ./src/request/api.js